import { DateTime } from "luxon";
import { useId } from "react";
import { DateInput } from "../../../../mantine/dates/DateInput/DateInput";

interface DatePickerCellProps {
  value: DateTime | undefined;
  firstPossibleDate?: DateTime;
  lastPossibleDate?: DateTime;
  placeholder?: string;
  onChange: (newDate: DateTime) => void;
}

function DatePickerCell({
  value,
  firstPossibleDate,
  lastPossibleDate,
  placeholder,
  onChange
}: DatePickerCellProps) {
  const formId = useId();

  const disabled = Boolean(
    firstPossibleDate &&
    DateTime.now().minus({ days: 1 }).hasSame(firstPossibleDate, "day")
  );

  function handleChangeDate(date: DateTime | null) {
    if (!date) {
      return;
    }

    onChange(date);
  }

  return (
    <DateInput
      className={!value ? "center" : ""}
      clearable={false}
      disabled={disabled}
      id={formId}
      maxDate={lastPossibleDate}
      minDate={firstPossibleDate}
      placeholder={placeholder}
      value={value}
      onChange={handleChangeDate}
    />
  );
}

export { DatePickerCell };
